import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

export default function ChoosePieceToStylePage({ user }) {
  const [pieces, setPieces] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return onSnapshot(
      collection(db, "users", user.uid, "wardrobe"),
      (snapshot) => {
        setPieces(snapshot.docs.map((item) => ({ id: item.id, ...item.data() })));
        setLoading(false);
      }
    );
  }, [user.uid]);

  return (
    <main className="min-h-screen bg-[#f8f3ef] px-6 py-14 text-stone-800">
      <div className="mx-auto max-w-6xl">
        <p className="text-xs uppercase tracking-[0.3em] text-rose-700">Share your styling talent</p>
        <h1 className="mt-3 max-w-4xl text-4xl font-semibold leading-tight text-stone-900 md:text-6xl">
          Start with one piece. Build the look around it.
        </h1>
        <p className="mt-5 max-w-2xl text-lg leading-8 text-stone-600">
          Choose one centerpiece from your wardrobe, then share the complete or
          cropped outfit you created around it.
        </p>

        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/style-requests?mode=help" className="border border-stone-500 px-5 py-3 text-sm text-stone-700 hover:border-rose-600 hover:text-rose-700">
            Or browse style questions
          </Link>
          <Link to="/wardrobe#add-piece" className="text-sm text-rose-700 underline self-center">
            Add another centerpiece
          </Link>
        </div>

        {loading && <p className="py-16 text-center text-stone-500">Opening your wardrobe…</p>}

        {!loading && pieces.length === 0 && (
          <div className="mt-12 border border-dashed border-stone-400 p-12 text-center">
            <h2 className="text-2xl text-stone-900">Add one piece before sharing a styled look.</h2>
            <Link to="/wardrobe#add-piece" className="mt-5 inline-block bg-rose-700 px-6 py-3 text-white">
              Add my first centerpiece
            </Link>
          </div>
        )}

        {!loading && pieces.length > 0 && (
          <div className="mt-12 grid gap-7 sm:grid-cols-2 lg:grid-cols-3">
            {pieces.map((piece) => (
              <article key={piece.id} className="border border-stone-300 bg-white p-4">
                {piece.imageUrl && (
                  <img src={piece.imageUrl} alt={piece.name} className="aspect-[4/5] w-full object-cover" />
                )}
                <p className="mt-4 text-xs uppercase tracking-wider text-stone-500">
                  {piece.category || "Loved piece"}
                </p>
                <h2 className="mt-1 text-xl text-stone-900">{piece.name}</h2>
                <Link
                  to={`/item/${piece.id}/style`}
                  className="mt-5 block bg-rose-700 px-5 py-3 text-center text-sm font-medium text-white hover:bg-rose-800"
                >
                  Style around this piece
                </Link>
              </article>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
